import { logger } from './logger'

// Separate caches for resolved values and pending promises
const resultCache: Record<string, string> = {}
const promiseCache: Record<string, Promise<any>> = {}

type FetchParams = {
  url: string
  cacheKey?: string
}

export async function fetchWithCache<T>(
  params: FetchParams | string,
  options?: any,
): Promise<T> {
  const { url, cacheKey } =
    typeof params === 'string' ? { url: params, cacheKey: undefined } : params
  const key = cacheKey || url
  logger('fetchWithCache.key', key)
  if (resultCache[key]) {
    try {
      return JSON.parse(resultCache[key]) as T
    } catch (error) {
      // If cached data is corrupted, clear it and refetch
      console.warn('[fetchWithCache] Corrupted cache data, clearing:', {
        key,
        error: error instanceof Error ? error.message : String(error),
      })
      delete resultCache[key]
    }
  }

  if (!promiseCache[key]) {
    logger('fetchWithCache.fetching', url)
    promiseCache[key] = $fetch<T>(url, { timeout: 30000, ...options })
  }

  try {
    const data = await promiseCache[key]
    resultCache[key] = JSON.stringify(data)
    // Return a deep clone to prevent mutations from affecting concurrent callers
    // who share the same promise
    return structuredClone(data)
  } finally {
    delete promiseCache[key]
  }
}
